import { Button, Skeleton, Slide, Typography } from "@mui/material";
import { Box, Container } from "@mui/system";
import useMediaQuery from "@mui/material/useMediaQuery";
import React, { useEffect, useState } from "react";
import { faArrowCircleRight } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link as RouterLink } from "react-router-dom";
import Slider from "react-slick";

export default function HomeCarousel({ slides }) {
  const mobile = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const [activeSlide, setActiveSlide] = useState(0);
  const [opacity, setOpacity] = useState(0);
  const [title, setTitle] = useState("");
  const [buttonText, setButtonText] = useState("");

  const settings = {
    dots: true,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  useEffect(() => {
    if (slides) {
      setTitle(slides[0].title);
      setButtonText(slides[0].button_text);
      setOpacity(1);
    }
  }, [slides]);

  useEffect(() => {
    if (slides) {
      setOpacity(0);
      setTimeout(() => {
        setTitle(slides[activeSlide].title);
        setButtonText(slides[activeSlide].button_text);
        setOpacity(1);
      }, 250);
    }
  }, [activeSlide]);

  let height = window.innerHeight;

  return (
    <Box
      id="home-carousel"
      sx={{
        position: "relative",
        //height:'calc('+window.innerHeight+'px - 100px)',
        height: "calc(100vh - 100px)",
        minHeight: "600px",
        maxHeight: "800px",
        overflow: "clip",
      }}
    >
      {/* {slides?.map((slide, i)=>{
                const isVideo=slide.media.match(/\.(mp4|mov|avi|wmv)$/) != null;
                const left=(i-activeSlide)*100;
                return(
                    <Box
                        key={i}
                        sx={{
                            position:'absolute',
                            top:0,
                            left:left+'vw',
                            transition:'left 0.5s',
                            width:'100vw',
                            height:'100%',
                        }}
                    >
                        {isVideo?
                            <video
                                src={slide.media}
                                autoPlay
                                loop
                                muted
                                playsInline
                                width='100%'
                                height='100%'
                                style={{
                                    objectFit:'cover'
                                }}
                            />
                        :
                            <Box
                                sx={{
                                    width:'100%',
                                    height:'100%',
                                    background:'url('+slide.media+')',
                                    backgroundSize:'cover',
                                    backgroundPosition:'center'
                                }}
                            />
                        }
                    </Box>
                );
            })}
            <Box
                sx={{
                    position:'absolute',
                    width:'100%',
                    height:'100%',
                    background:"linear-gradient(90deg, rgba(13,96,168,1) 33%, rgba(0,0,0,0) 100%)",
                    mixBlendMode:'multiply'
                }}
            />
            <Container maxWidth='xl'
                sx={{
                    height:{
                        xs:'calc(100% - 160px)',
                        md:'calc(100% - 80px)'
                    },
                    display:'flex',
                    flexDirection:'column',
                    justifyContent:{
                        xs:'center',
                        md:'flex-start'
                    },
                    color:'#fff',
                    transform:'translateZ(1px)'
                }}
            >
                <Box
                    sx={{
                        mt:{
                            xs:0,
                            md:'10%'
                        },
                        width:{
                            xs:'100%',
                            lg:'66%'
                        }
                    }}
                >
                    <Box
                        sx={{
                            display:'flex',
                            mb:'1rem'
                        }}
                    >
                        {Array(slides?.length).fill(0).map((x, i)=>{
                            return(
                                <Box
                                    onClick={()=>setActiveSlide(i)}
                                    sx={{
                                        width:'20px',
                                        height:'20px',
                                        borderRadius:'50%',
                                        border:'5px solid white',
                                        background: activeSlide===i? 'white' : 'none',
                                        transition:'background 0.5s',
                                        cursor:'pointer',
                                        mr:'1rem'
                                    }}
                                    key={i}
                                />
                            )
                        })}
                    </Box>
                    {slides?
                        <>
                            <Typography variant='h1'
                                sx={{
                                    fontSize:'3rem',
                                    fontWeight:600,
                                    mb:'1rem',
                                    opacity:opacity,
                                    transition:'opacity 0.25s'
                                }}
                            >
                                {title}
                            </Typography>
                            <Button
                                component={RouterLink}
                                to={slides?.[activeSlide].button_link}
                                sx={{
                                    mt:'1rem',
                                    p:'0.5rem 1rem',
                                    fontSize:'1.1rem',
                                    fontWeight:500,
                                    color:'#fff',
                                    border:'2px solid white',
                                    borderRadius:'2rem',
                                    opacity:opacity,
                                    transition:'opacity 0.25s, background 0.25s',
                                    '&:hover':{
                                        background:'rgba(255, 255, 255, 0.5)'
                                    }
                                }}
                            >
                                {buttonText}
                            </Button>
                        </>
                    :
                        <>
                            <Skeleton height={100}/>
                            <Skeleton height={80} width={200}/>
                        </>
                    }
                </Box>
            </Container> */}
      <Slider {...settings}>
        {slides?.map((slide, i) => {
          const isVideo = slide.media.match(/\.(mp4|mov|avi|wmv)$/) != null;
          //const left = (i - activeSlide) * 100;
          return (
            <Box
              key={i}
              sx={{
                position: "relative",
                top: 0,
                //left: left + 'vw',
                transition: "left 0.5s",
                width: "100vw",
                height: "100%",
                height: "100vh",
              }}
            >
              {isVideo ? (
                <video
                  src={slide.media}
                  autoPlay
                  loop
                  muted
                  playsInline
                  width="100%"
                  height="100%"
                  style={{
                    objectFit: "cover",
                  }}
                />
              ) : (
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    background: "url(" + slide.media + ")",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                />
              )}
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background:
                    "linear-gradient(90deg, rgba(13,96,168,1) 33%, rgba(0,0,0,0) 100%)",
                  mixBlendMode: "multiply",
                }}
              />
              <Container
                maxWidth="xl"
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: {
                    xs: "calc(100% - 160px)",
                    md: "calc(100% - 80px)",
                  },
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: {
                    xs: "center",
                    md: "flex-start",
                  },
                  color: "#fff",
                  //transform: "translateZ(1px)",
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
              >
                <Box
                  sx={{
                    mt: {
                      xs: 0,
                      md: "40%",
                      lg: "25%",
                    },
                    transform: {
                      md: "translateY(-50%)",
                    },
                    width: {
                      xs: "100%",
                      lg: "66%",
                    },
                    textAlign: mobile ? "center" : "left",
                  }}
                >
                  {/* <Box
                                        sx={{
                                            display: 'flex',
                                            mb: '1rem',
                                            justifyContent: mobile ? 'center' : 'flex-start',
                                            textAlign: mobile ? 'center' : 'left'
                                        }}
                                    >
                                        {Array(slides?.length).fill(0).map((x, i) => {
                                            return (
                                                <Box
                                                    onClick={() => setActiveSlide(i)}
                                                    sx={{
                                                        width: '20px',
                                                        height: '20px',
                                                        borderRadius: '50%',
                                                        border: '5px solid white',
                                                        background: activeSlide === i ? 'white' : 'none',
                                                        transition: 'background 0.5s',
                                                        cursor: 'pointer',
                                                        mr: '1rem'
                                                    }}
                                                    key={i}
                                                />
                                            )
                                        })}
                                    </Box> */}

                  <Typography
                    variant="h1"
                    sx={{
                      fontSize: "3rem",
                      fontWeight: 600,
                      mb: "1rem",
                      opacity: opacity,
                      transition: "opacity 0.25s",
                      textAlign: mobile ? "center" : "left",
                    }}
                  >
                    {slide?.title}
                  </Typography>
                  <Button
                    component={RouterLink}
                    to={slide?.button_link}
                    sx={{
                      mt: "1rem",
                      mx: mobile ? "auto" : 0,
                      p: "0.5rem 1rem",
                      fontSize: "1.1rem",
                      fontWeight: 500,
                      color: "#fff",
                      border: "2px solid white",
                      borderRadius: "2rem",
                      opacity: opacity,
                      transition: "opacity 0.25s, background 0.25s",
                      textAlign: mobile ? "center" : "left",
                      "&:hover": {
                        background: "rgba(255, 255, 255, 0.5)",
                      },
                    }}
                  >
                    {buttonText}
                  </Button>
                </Box>
              </Container>
            </Box>
          );
        })}
      </Slider>
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          height: {
            xs: "120px",
            md: "80px",
          },
        }}
      >
        <Button
          component={RouterLink}
          to={"/services/consulting/"}
          sx={{
            p: "1rem",
            height: {
              xs: "60px",
              md: "100%",
            },
            width: {
              xs: "100%",
              md: "50%",
            },
            justifyContent: {
              xs: "space-evenly",
              md: "center",
            },
            backgroundColor: "rgba(233, 83, 28, 0.9)",
            color: "#fff",
            fontSize: {
              xs: "1.2rem",
              md: "1.6rem",
            },
            borderRadius: 0,
            "&:hover": {
              backgroundColor: "rgba(233, 83, 28, 0.9)",
            },
            "&:hover .arrow-right": {
              translate: "1rem 1px !important",
            },
          }}
        >
          S2 Consultancy Services
          <FontAwesomeIcon
            icon={faArrowCircleRight}
            className="arrow-right"
            style={{
              translate: "0.5rem 1px",
              transition: "translate 0.2s",
            }}
          />
        </Button>
        <Button
          component={RouterLink}
          to={"/services/s2-riskwise-software/"}
          sx={{
            p: "1rem",
            height: {
              xs: "60px",
              md: "100%",
            },
            width: {
              xs: "100%",
              md: "50%",
            },
            justifyContent: {
              xs: "space-evenly",
              md: "center",
            },
            backgroundColor: "rgba(0, 94, 170, 0.9)",
            color: "#fff",
            fontSize: {
              xs: "1.2rem",
              md: "1.6rem",
            },
            borderRadius: 0,
            "&:hover": {
              backgroundColor: "rgba(0, 94, 170, 0.9)",
            },
            "&:hover .arrow-right": {
              translate: "1rem 1px !important",
            },
          }}
        >
          S2 RiskWise Software
          <FontAwesomeIcon
            icon={faArrowCircleRight}
            className="arrow-right"
            style={{
              translate: "0.5rem 1px",
              transition: "translate 0.2s",
            }}
          />
        </Button>
      </Box>
    </Box>
  );
}
